import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { useHistory } from "react-router";
import { Helmet } from "react-helmet";
import handleApiError from "../../helpers/handleApiError";
import { defaultTitle } from "../../config";
import { format } from "date-fns";
// import ExcelExportDataAction from "./ExcelExportDataAction";
const today = new Date();
function CODReport({ setLoading }) {
  return "COD Report";
  //   const history = useHistory();

  //   const {
  //     data: CODRecords,
  //     mutate,
  //     isLoading,
  //     isError,
  //   } = useMutation({
  //     mutationFn: () => getCODReport(),
  //     mutationKey: ["CODReport"],
  //     onError: (error) => handleApiError(error, history),
  //   });

  //   useEffect(() => {
  //     mutate();
  //   }, [mutate]);
  //   return (
  //     <>
  //       <Helmet>
  //         <title>COD Report - {defaultTitle}</title>
  //       </Helmet>
  //       <div
  //         className="heading-containter center-flex-container tw-relative"
  //         style={{ flexDirection: "column" }}
  //       >
  //         <h1>COD Report</h1>
  //         {/*
  //         <div className="tw-absolute tw-right-0 tw-top-0">
  //           <ExcelExportDataAction
  //             className="export-button"
  //             alt="Export COD Report"
  //             title="Export COD Report"
  //             fileName={`COD Report - ${format(today, "yyyy-mm-dd")}`}
  //             getExportData={getCODReportExportData}
  //           />
  //         </div> */}
  //       </div>
  //       <br />
  //       <CODReportTable
  //         codRecords={CODRecords?.data || []}
  //         onDetailsClick={handleDetailsClick}
  //         isLoading={isLoading}
  //         isError={isError}
  //       />
  //     </>
  //   );
}
export default CODReport;
